import React from 'react';
import { TabF, TabsF } from 'components/tabs/tabfile';
import RemindersTabName from 'components/invoiceReminders/RemindersTabName';
import UseContext from 'hooks/useContext';

// The tabs of the « Facturation » page. `remindersToDo`: the count of "À
// faire" of the reminders (JBWEB-1283), shown on their tab.
const BillingSubNav = ({ remindersToDo }) => {
  const { language } = UseContext();
  const text = (key, fallback) =>
    language.getValue(`invoiceList.${key}`, fallback);

  return (
    <TabsF>
      <TabF
        label={'invoices'}
        tabName={text('tabInvoices', 'Factures clients')}
      />
      <TabF
        label={'reminders'}
        tabName={
          <RemindersTabName
            label={text('tabReminders', 'Rappels / Relances')}
            toDo={remindersToDo}
          />
        }
      />
    </TabsF>
  );
};

export default BillingSubNav;
